module.exports = __webpack_public_path__ + "6853a174215676863e6a57cffa4180ef.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-michael.png
// module id = 660
// module chunks = 0